import { render } from "./ClustersContainer.vue?vue&type=template&id=5565e0c6"
import script from "./ClustersContainer.vue?vue&type=script&lang=js"
export * from "./ClustersContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__